import { render, staticRenderFns } from "./DeleteModuleModal.vue?vue&type=template&id=cd8a8fd0"
import script from "./DeleteModuleModal.vue?vue&type=script&lang=js"
export * from "./DeleteModuleModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports